import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { UiService } from "@services/ui.service";
import { RecurringOrder } from "@classes/recurring-order/recurring-order";
import { RecurringOrdersService } from "@services/recurring-orders.service";


@Injectable()
export class RecurringOrderResolver  {
    constructor(
        private recurringOrdersSrv: RecurringOrdersService,
        private uiSrv: UiService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<RecurringOrder> {
        const id = route.paramMap.get('id');
        this.uiSrv.routeLoadingStateChanged.next(true);
        return this.recurringOrdersSrv.get(id)
        .pipe(
            tap(() => {
                this.uiSrv.routeLoadingStateChanged.next(false);
            })
        );
    }
}
